import {Inject, Injectable} from '@angular/core';
import {AgentModel} from "../models/agent.model";
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";

@Injectable({providedIn: 'root'})
export class AgentsChanelService extends EntitiesChannel<AgentModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "agents_changed";
  }

  getPartialChannelName(): String {
    return "agents_partial_changed";
  }

  getCreateChannelName(): String {
    return "agents_created";
  }

}
